import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useQuizSettings(data = {}) {
  const { enabled = false, configs = {}, quizId } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getData() {
    return privateFetch.get(`/v1/admin/quiz/${quizId}/settings`, configs).then((res) => res.data);
  }

  return useQuery(['quiz-settings', { data }], getData, { enabled, keepPreviousData: true });
}

export default useQuizSettings;
